export default __webpack_public_path__ + "static/media/Pic3.e88f70d5.png";